<template>
  <div class="w-full">
    <template v-if="직접입력여부() || isCustomInput">
      <div class="flex flex-col items-center">
        <div>
          <ml-input class="w-full" v-model="select" @blur="blurCustomInput" :renderFocus="true" />
        </div>
        <div class="mt-1">
          <vs-button class="" size="small" radius color="secondary" type="border" icon="close" @click="handleCancelCustom"></vs-button>
        </div>
      </div>
    </template>
    <vs-select v-else autocomplete v-model="select" :disabled="readonly" @input="handleChange" class="w-full">
      <vs-select-item v-for="(data, index) in list" :key="index" :text="data.text" :value="data.value" />
      <vs-select-item v-show="false" :value="select" :text="select" />
    </vs-select>
  </div>
</template>

<script>
export default {
  name: "CheckTypeASelector",
  props: {
    value: String,
    readonly: Boolean,
  },
  watch: {
    value(value) {
      this.customInput = "";
      this.select = value;
    },
  },
  computed: {
    list() {
      return [
        { text: "기계(설비)적 요인", value: "기계(설비)적 요인" },
        { text: "전기적 요인", value: "전기적 요인" },
        { text: "화학(물질)적 요인", value: "화학(물질)적 요인" },
        { text: "생물학적 요인", value: "생물학적 요인" },
        { text: "작업특성 요인", value: "작업특성 요인" },
        { text: "작업환경 요인", value: "작업환경 요인" },
        { text: "직접입력", value: "직접입력" },
      ];
    },
  },
  data() {
    return {
      select: "",
      customInput: "",
      isCustomInput: false,
    };
  },

  created() {
    if (this.value) {
      this.select = this.value;
    } else {
      this.select = "기계(설비)적 요인";
      this.$emit("input", this.select.toString());
    }
  },

  methods: {
    handleChange() {
      this.$emit("input", this.select.toString());
      this.$emit("change", this.select.toString());

      if (this.select.toString() === "직접입력") {
        this.isCustomInput = true;
      } else {
        this.isCustomInput = false;
      }
    },
    blurCustomInput() {
      this.$emit("input", this.select.toString());
      this.$emit("change", this.select.toString());
    },
    직접입력여부() {
      // data 값이 "직접입력" 이거나 list 값 중에 없는 값이면 true
      return this.select && (this.select === "직접입력" || !this.list.find((item) => item.value === this.select));
    },
    handleCancelCustom() {
      this.select = "기계(설비)적 요인";
      this.isCustomInput = false;
    },
  },
};
</script>

<style scoped></style>
